/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {Tooltip} from './Tooltip';
import {ClayTooltipProvider} from './TooltipProvider';

export {Tooltip, ClayTooltipProvider};

export default Tooltip;
